import { Button, Card, Checkbox, Col, Form, message, Row } from "antd";
import { FC } from "react";
import { useForm } from "react-hook-form";
import { useMutation, useQuery, useQueryClient } from "react-query";
import { useNavigate, useParams } from "react-router-dom";
import cmaApi from "../../../../api/cmaApi";
import InputField from "../../../../components/InputField";
import InputNumberWrap from "../../../../components/InputNumber";
import Loading from "../../../../components/Loading";
import TopContent from "../../../../components/TopContent";
import PageWrap from "../../../../layout/PageWrap";
import { appRoutes } from "../../../../routes/routes";
import { formItemLayoutSm } from "../../../../utils/constants";
import { ConvertSlug } from "../../../../utils/functions/convertSlug";
import { messages } from "../../../../utils/messages";

interface CmaCategoryFormProps {
  type: number;
}

const CmaCategoryForm: FC<CmaCategoryFormProps> = ({ type }) => {
  const { id } = useParams();
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  const { data, isLoading, isFetching } = useQuery(
    ["cma_article_categories", id],
    () => cmaApi.getCategoryDetails(id),
    { enabled: type === 2 }
  );

  const {
    handleSubmit,
    control,
    setValue,
    formState: { errors },
  } = useForm();

  const mutationEdit = useMutation(cmaApi.editCategory, {
    onSuccess: async (res: any) => {
      if (res.statusCode === 200) {
        message.success(messages.updateSuccess);
        await queryClient.invalidateQueries("cma_article_categories");
        navigate(appRoutes.CMA.ARTICLE_CATEGORIES.LIST);
        window.scrollTo(0, 0);
      } else {
        message.error(res?.data?.message ?? messages.error);
      }
    },
    onError: (err: any) => {
      message.error(err?.data?.message ?? messages.error);
    },
  });

  const mutationAdd = useMutation(cmaApi.addCategory, {
    onSuccess: async (res: any) => {
      if (res.statusCode === 200) {
        message.success(messages.addSuccess);
        await queryClient.invalidateQueries("cma_article_categories");
        navigate(appRoutes.CMA.ARTICLE_CATEGORIES.LIST);
        window.scrollTo(0, 0);
      } else {
        message.error(res?.data?.message ?? messages.error);
      }
    },
    onError: (err: any) => {
      message.error(err?.data?.message ?? messages.error);
    },
  });

  const onSubmit = (dt: any) => {
    const payload = {
      ...dt,
      hienthi:
        dt?.hienthi ??
        (type === 2 ? data?.data?.hienthi ?? false : false),
    };
    if (type === 2) mutationEdit.mutate({ id, data: payload });
    if (type === 1) mutationAdd.mutate(payload);
  };

  return (
    <PageWrap
      title="CMA · Danh mục bài viết"
      content={
        <>
          <TopContent
            content={
              <Row>
                <Col>
                  <b>CMA · Danh mục bài viết</b>
                </Col>
              </Row>
            }
          />
          <div className="content">
            {isLoading || isFetching ? (
              <Loading />
            ) : (
              <Card bordered={false}>
                <Form {...formItemLayoutSm} className="slider-form">
                  <InputField
                    label="Tiêu đề"
                    name="ten_vi"
                    control={control}
                    setValue={setValue}
                    defaultValue={data?.data?.ten_vi}
                    errorMsg={errors?.ten_vi?.message}
                    rules={{ required: "Vui lòng nhập tiêu đề" }}
                    onChange={(e: any) => {
                      setValue("slug_vi", ConvertSlug(e.target.value));
                    }}
                  />
                  <InputField
                    label="Slug"
                    name="slug_vi"
                    control={control}
                    setValue={setValue}
                    defaultValue={data?.data?.slug_vi}
                    errorMsg={errors?.slug_vi?.message}
                    rules={{ required: "Vui lòng nhập slug" }}
                  />
                  <InputNumberWrap
                    label="STT"
                    name="stt"
                    control={control}
                    defaultValue={data?.data?.stt ?? 1}
                    onBlur={(e: any) => {
                      if (e.target.value === "") setValue("stt", 1);
                    }}
                    min={1}
                  />
                  <Form.Item className="checkbox">
                    <Row>
                      <Col xs={24} sm={20}>
                        <Checkbox
                          defaultChecked={data?.data?.hienthi}
                          name="hienthi"
                          onClick={(e: any) => {
                            setValue("hienthi", e.target.checked);
                          }}
                        />
                        &nbsp;Hiển thị
                      </Col>
                    </Row>
                  </Form.Item>
                  <Row justify="start" gutter={[10, 0]}>
                    <Col>
                      <Button
                        type="primary"
                        danger
                        onClick={handleSubmit(onSubmit)}
                      >
                        Lưu
                      </Button>
                    </Col>
                    <Col>
                      <Button
                        onClick={() =>
                          navigate(appRoutes.CMA.ARTICLE_CATEGORIES.LIST)
                        }
                      >
                        Hủy
                      </Button>
                    </Col>
                  </Row>
                </Form>
              </Card>
            )}
          </div>
        </>
      }
    />
  );
};

export default CmaCategoryForm;
